export function enumHasValue(obj: any, value: string): boolean {
  return Object.values(obj).includes(value)
}
